var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listContainer"},[_c('transition-group',{staticClass:"list",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.results),function(project){return _c('li',{key:project.ref,staticClass:"list-item-trans"},[_c('PresentationItem',{attrs:{"project":_vm.getRef(project)}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }